import { http } from '../../utils/http'

export interface SaveFeedBackDto {
    id: number
    email: string 
    body: string
    feedBackTime: string
}

export const insertFeedBackAsync = async (
    feedBack : SaveFeedBackDto,
    token: string
) : Promise<boolean> => {
    const result = await http<SaveFeedBackDto, null>({
        method: 'post',
        path: 'FeedBack',
        accessToken: token,
        body: feedBack
    })
    return (result.ok)
}